import { FC } from "react";

interface Props {
  value?: number | string;
  type?: "currency" | "percentage";
  lang?: string;
  suffix?: string;
}

export const FormattedNumber: FC<Props> = ({
  value,
  type = "currency",
  lang = "de",
  suffix = "",
}) => {
  const isPercentage = type === "percentage";
  return (
    <span className="formatted-number">
      {value?.toLocaleString(undefined, {
        minimumFractionDigits: isPercentage ? 1 : 2,
        maximumFractionDigits: isPercentage ? 1 : 2,
      })}
      {suffix && <span>{suffix}</span>}
    </span>
  );
};
